/**
 * How the panel names each quotation status (ADR 0005, BR-017).
 *
 * The backend enum stays the single source of truth for the lifecycle; this only maps it to
 * the language the internal team uses when talking about a request.
 */
export const quotationStatusLabels: Record<string, string> = {
  QUOTED: 'Cotizado',
  APPROVED: 'Aprobado',
  REJECTED: 'Rechazado',
};

export function getQuotationStatusLabel(status: string): string {
  return quotationStatusLabels[status] || status;
}

/// Every status the lifecycle can be in, in the order the flow goes through them. Used by the
/// list's status filter.
export const allQuotationStatuses = Object.keys(quotationStatusLabels);

/// What the list shows when no status is chosen: the requests still being worked on. Approved
/// and rejected ones are kept and found by filtering (BR-017).
export const defaultQuotationStatusFilter = 'QUOTED';

/// The filter value that shows every status. Lives only in the URL: the backend is asked for
/// no status at all.
export const allQuotationStatusesFilter = 'ALL';
